import http from 'axios';
import { API_URL_POST, FUNCTION_KEY, APIM_SUB_KEY } from '../runtimeConfig';

const VersionService = () => {
    const getVersion = async () => {
        let url = API_URL_POST + '/version' + '?code=' + FUNCTION_KEY;

        const httpOptions = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Ocp-Apim-Subscription-Key': APIM_SUB_KEY
            }
        };
        try {
            const res = await http.post(url, httpOptions);
            return res.data;
        } catch (err) {
            console.log(err);
        }
    }

    return { getVersion };

}

export default VersionService;